module.exports = __webpack_public_path__ + "static/media/20b.45745c2e.jpg";